import styled from '@emotion/styled';
import React from 'react';
import { css } from '@emotion/core';
import moment from 'moment';
import {fontSize} from '../../../constants';
import IconSvg from '../../common/IconSvg';

export const NotesAndSchemeWrapper = styled.div`
  text-align: center;
  margin-left: auto;
  flex-shrink: 0;
  min-height: 428px;
  display: flex;
  flex-direction: column;
  width: 50%;
  align-items: flex-end;
`;

export const Notes = styled.div`
  min-height: 100px;
  border: 1px solid ${({ theme }) => theme.colors.greyMid};
  box-shadow: 0 1px 7px 0 rgba(0, 105, 250, 0.16);
  border-radius: 5px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 4px 19.4px;
  width: 100%;
`;

export const ItemHeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemHeader = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.small};
  color: ${({ theme, color }) => color || theme.colors.greyDark};
  line-height: ${({ theme }) => theme.lineHeight.huge};
  margin-bottom: 0;
  margin-left: ${({ marginLeft }) => marginLeft || null};
`;

export const TimelineSpacer = styled.div`
  height: 0px;
  border-bottom: 1px solid ${({green, theme})=> green ? theme.colors.greenBright : theme.colors.greyMid };
  width: ${({width})=>width || 'auto'};
`;

const TimelineStartDot = styled.div`
  border-width: 1px;
  background-color: ${({theme}) => theme.colors.whiteLightBackground};
  border-style: solid;
  ${({margin})=> margin ? `margin: ${margin}` : '' }; 
  ${({green, theme, uneven})=> green ? `
    width: 21px;
    min-height: 21px;
    border-radius: 10.5px;
    border-color: ${theme.colors.greenBright};
    background: radial-gradient(
      circle,
      ${theme.colors.greenBright} 0,
      ${theme.colors.greenBright} 6px,
      ${theme.colors.whiteLightBackground} 7px
    );
    margin: ${uneven ? '-10px 0 0 0' : '0 0 -10px 0'};
  ` : `
    width: 18px;
    min-height: 18px;
    border-radius: 9px;
    border-color: ${theme.colors.greyMid};
    margin: ${uneven ? '-9px 0 0 0' : '0 0 -9px 0'};
    background: radial-gradient(
      circle,
      ${theme.colors.greyMid} 0,
      ${theme.colors.greyMid} 5px,
      ${theme.colors.whiteLightBackground} 6px
    );
  `}
`;

const TimelineBar = styled.div`
  width: 1px;
  ${({green, theme}) => green ? `
    min-height: 21px;
    background: ${theme.colors.greenBright};
  ` : `
    min-height: 22px;
    background: ${theme.colors.greyMid};
  `}
`;

const TimelineEndDot = styled.div`
  min-height: 5px;
  width: 5px;
  border-radius: 2.5px;
  ${({margin})=> margin ? `margin: ${margin}` : '' };
  ${({green, theme}) => green ? `
    background: ${theme.colors.greenBright};
  ` : `
    background: ${theme.colors.greyMid};
  `}
`;

export const StatusStep = ({index, currentStep, title, dateTime=null })=>{
  const uneven = !!(index%2);
  return (
    <div
      css={css`
        width: 0;
        height: 0;
        display: flex;
        align-items: center;
        z-index: 1;
        flex-direction: ${uneven ? 'column' : 'column-reverse'};
      `}
    >
      {index === currentStep ? (
        <div>
          <IconSvg type="pin-point" height={41} width={26} rotate={uneven ? "180deg" : "0deg"} />
        </div>
      ) : (
        <React.Fragment>
          <TimelineStartDot green={index < currentStep} uneven={uneven} />
          <TimelineBar green={index < currentStep} />
          <TimelineEndDot green={index < currentStep} />
        </React.Fragment>
      )}
      <div
        css={css`
          text-align: left;
          white-space: pre;
          font-size: 9px;
          ${!uneven && index !== 0 && 'margin-bottom: 10px;'}
          ${uneven && 'margin-top: 10px;'}
          &::first-line {
            font-weight: bold;
            font-size: ${fontSize.small};
          }
        `}
      >
        {title}{'\n'}
        {dateTime ? moment(dateTime).format('MMMM D, YYYY[\n]hh:mm A') : null}
      </div>
    </div>
  )
}
